import { useQuery } from '@tanstack/react-query'
import { useQueryClient } from '@tanstack/react-query'
import { getAvailabilityConfiguration, updateAvailabilityConfiguration } from '../../services/configuration.service'
import type { AvailabilityConfigurationType, CloseDateType, OpenDateType } from '../types/availability.types'
import { QueryKeys } from '../../../../constants/queryKeys.constants'
import { DEFAULT_NEXT_DAY_BOOKING_CUTOFF_TIME } from '../../../../constants/configuration.constants'

export const useAvailabilityConfiguration = (enabled = true) => {
  const queryClient = useQueryClient()

  const { data: configuration, isLoading } = useQuery<AvailabilityConfigurationType>({
    queryKey: [QueryKeys.CONFIGURATION, 'availability'],
    queryFn: getAvailabilityConfiguration,
    enabled,
  })

  const update = async (data: Partial<AvailabilityConfigurationType>) => {
    await updateAvailabilityConfiguration(data)
    queryClient.invalidateQueries({ queryKey: [QueryKeys.CONFIGURATION, 'availability'] })
  }

  const openDates: OpenDateType[] = configuration?.openDates ?? []
  const closeDates: CloseDateType[] = configuration?.closeDates ?? []
  const nextDayBookingCutoffTime = configuration?.nextDayBookingCutoffTime || DEFAULT_NEXT_DAY_BOOKING_CUTOFF_TIME

  return {
    configuration,
    openDates,
    closeDates,
    nextDayBookingCutoffTime,
    isLoading,
    update,
  }
}
